import {I18n} from 'react-redux-i18n';

class SubscriptionType {

  get type() {
    return null;
  }

  get name() {
    return null;
  }

  isSubscription() {
    return null;
  }

  isUnsubscription() {
    return this.isSubscription() === false;
  }

}

export class NotSubscribed extends SubscriptionType {

  get type() {
    return 'NOT_SUBSCRIBED';
  }

  get name() {
    return I18n.t('page.dvrHealth.subscriptionPanel.subscriptionTypes.notSubscribed');
  }

  isSubscription() {
    return false;
  }

}

export class RealTime extends SubscriptionType {

  get type() {
    return 'DVR_UNHEALTHY_REAL_TIME';
  }

  get name() {
    return I18n.t('page.dvrHealth.subscriptionPanel.subscriptionTypes.realTime');
  }

  isSubscription() {
    return true;
  }

}

export class Daily extends SubscriptionType {

  get type() {
    return 'DVR_UNHEALTHY_DAILY';
  }

  get name() {
    return I18n.t('page.dvrHealth.subscriptionPanel.subscriptionTypes.dailyAt5AmCT');
  }

  isSubscription() {
    return true;
  }

}

export class RealTimeAndDaily extends SubscriptionType {

  get type() {
    return 'DVR_UNHEALTHY_DAILY,DVR_UNHEALTHY_REAL_TIME';
  }

  get name() {
    return I18n.t('page.dvrHealth.subscriptionPanel.subscriptionTypes.realTimeAndDailyAt5AmCT');
  }

  isSubscription() {
    return true;
  }

}

export const NOT_SUBSCRIBED = new NotSubscribed();
export const REAL_TIME = new RealTime();
export const DAILY = new Daily();
export const REAL_TIME_AND_DAILY = new RealTimeAndDaily();

export default class SubscriptionTypes {

  static get NOT_SUBSCRIBED() {
    return NOT_SUBSCRIBED;
  }

  static get REAL_TIME() {
    return REAL_TIME;
  }

  static get DAILY() {
    return DAILY;
  }

  static get REAL_TIME_AND_DAILY() {
    return REAL_TIME_AND_DAILY;
  }

  static all() {
    return [
      NOT_SUBSCRIBED,
      REAL_TIME,
      DAILY,
      REAL_TIME_AND_DAILY
    ];
  }

  static get(subscriptionTypeKey) {
    return SubscriptionTypes
      .all()
      .find(subscriptionType => subscriptionType.type === subscriptionTypeKey);
  }

}
